module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1515-bc43f031eb5d64e582986898592ae445.png";